import { Stack, Typography, Divider } from "@mui/material";
import React from 'react';

function FormulaireFerme() {

    return (
        <Stack>
            <Typography variant="h4" align="center">
                Inscription bénévoles, auteurs et autrices, animateurs et animatrices pro,
                intervenants et intervenantes PAJ 2026 - 25/26 Avril
            </Typography>
            <Typography variant="h5" align="center" color="grey" mt={2} mb={3}>
                LA DATE LIMITE D'INSCRIPTION EST DEPASSE (10 AVRIL 2026)
            </Typography>

            <Typography variant="body1" align="justify" mb={3}>
                Pour toute questions, merci de nous contacter via le mail <a href="mailto:benevolespaj@gmail.com">benevolespaj@gmail.com</a>
            </Typography>

        </Stack >
    );

}

export default FormulaireFerme;